/* Sniff & Shift Event Calendar — vanilla JS enhancement over server-rendered data.
   Reads the JSON island rendered by sections/sns-event-calendar.liquid; no
   network requests, no external services, works entirely from Shopify data. */
(function () {
  "use strict";
  var root = document.getElementById("sns-cal");
  if (!root) return;
  var dataEl = document.getElementById("sns-cal-data");
  var events = [];
  try { events = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }

  var MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var MON3 = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  var DOW = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
  var STATUS_LABEL = { GOING: "Definitely going", THINKING: "Thinking about it", SAVED: "Saved for later" };
  var EVENT_NOTE = { cancelled: "Event cancelled", not_attending: "We're no longer attending", passed: "This event has passed" };

  // index events by day (multi-day events appear on every day)
  var byDay = {};
  events.forEach(function (ev) {
    (ev.days || []).forEach(function (d) {
      (byDay[d.date] = byDay[d.date] || []).push({ ev: ev, day: d });
    });
  });

  var today = new Date();
  var todayKey = today.getFullYear() + "-" + pad(today.getMonth() + 1) + "-" + pad(today.getDate());
  var view = { y: today.getFullYear(), m: today.getMonth(), filter: "all" };

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function keyOf(y, m, d) { return y + "-" + pad(m + 1) + "-" + pad(d); }
  function clock(hhmm) {
    if (!hhmm) return null;
    var h = parseInt(hhmm.slice(0, 2), 10), m = hhmm.slice(3, 5);
    var ap = h >= 12 ? "PM" : "AM"; h = h % 12 || 12;
    return h + (m === "00" ? "" : ":" + m) + " " + ap;
  }
  function fmtDate(iso) {
    var p = iso.split("-");
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12)).toLocaleDateString("en-US",
      { timeZone: "UTC", weekday: "long", month: "long", day: "numeric", year: "numeric" });
  }
  function visible(ev) {
    if (view.filter === "all") return true;
    return ev.state === view.filter;   // state filters (PA, NJ…)
  }

  // ---------- month grid ----------
  var grid = root.querySelector(".sns-cal__grid");
  var title = root.querySelector(".sns-cal__title");
  function render() {
    title.textContent = MONTHS[view.m] + " " + view.y;
    grid.querySelectorAll(".sns-cal__cell").forEach(function (c) { c.remove(); });
    var first = new Date(view.y, view.m, 1);
    var startIdx = (first.getDay() + 6) % 7;             // Monday-first
    var start = new Date(view.y, view.m, 1 - startIdx);
    for (var i = 0; i < 42; i++) {
      var d = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
      var key = keyOf(d.getFullYear(), d.getMonth(), d.getDate());
      var cell = document.createElement("div");
      cell.className = "sns-cal__cell" + (d.getMonth() !== view.m ? " sns-cal__cell--out" : "") +
        (key === todayKey ? " sns-cal__cell--today" : "");
      cell.setAttribute("role", "gridcell");
      var num = document.createElement("span");
      num.className = "sns-cal__num"; num.textContent = d.getDate();
      cell.appendChild(num);
      (byDay[key] || []).forEach(function (item) {
        if (!visible(item.ev)) return;
        var chip = document.createElement("button");
        chip.type = "button";
        chip.className = "sns-chip sns-chip--" + item.ev.status +
          (item.ev.eventStatus === "cancelled" ? " sns-chip--cancelled" : "");
        var t = clock(item.day.start);
        chip.textContent = (t ? t + " · " : "") + item.ev.title;
        chip.setAttribute("aria-label", item.ev.title + ", " + fmtDate(key) + ", " +
          (STATUS_LABEL[item.ev.status] || "") + (EVENT_NOTE[item.ev.eventStatus] ? ", " + EVENT_NOTE[item.ev.eventStatus] : ""));
        chip.addEventListener("click", function () { openModal(item.ev, key); });
        cell.appendChild(chip);
      });
      grid.appendChild(cell);
    }
  }
  root.querySelector("[data-prev]").addEventListener("click", function () {
    view.m--; if (view.m < 0) { view.m = 11; view.y--; } render();
  });
  root.querySelector("[data-next]").addEventListener("click", function () {
    view.m++; if (view.m > 11) { view.m = 0; view.y++; } render();
  });
  root.querySelector("[data-today]").addEventListener("click", function () {
    view.y = today.getFullYear(); view.m = today.getMonth(); render();
  });

  // ---------- filters ----------
  var states = {};
  events.forEach(function (ev) { if (ev.state) states[ev.state] = 1; });
  var fwrap = root.querySelector(".sns-cal__filters");
  var filters = [["all", "All"]]
    .concat(Object.keys(states).sort().map(function (s) { return [s, s]; }));
  // A lone "All" chip is noise — only show the row when there's a real choice.
  if (filters.length < 2) fwrap.style.display = "none";
  filters.forEach(function (f) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "sns-cal__filter"; b.textContent = f[1];
    b.setAttribute("aria-pressed", f[0] === "all" ? "true" : "false");
    b.addEventListener("click", function () {
      view.filter = f[0];
      fwrap.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", "true");
      render(); renderUp();
    });
    fwrap.appendChild(b);
  });

  // ---------- Coming Up ----------
  var upList = root.querySelector(".sns-up__list");
  var upMore = root.querySelector("[data-more]");
  var upShown = 6;
  function upcoming() {
    return events.filter(function (ev) {
      return visible(ev) && ev.eventStatus !== "passed" &&
        (ev.days || []).some(function (d) { return d.date >= todayKey; });
    }).sort(function (a, b) { return a.days[0].date < b.days[0].date ? -1 : 1; });
  }
  function renderUp() {
    upList.innerHTML = "";
    var list = upcoming();
    list.slice(0, upShown).forEach(function (ev) {
      var d = ev.days.filter(function (x) { return x.date >= todayKey; })[0] || ev.days[0];
      var p = d.date.split("-");
      var li = document.createElement("li");
      var badgeCls = ev.eventStatus === "scheduled" ? ev.status : ev.eventStatus;
      var badgeTxt = ev.eventStatus === "scheduled" ? STATUS_LABEL[ev.status] : EVENT_NOTE[ev.eventStatus];
      li.innerHTML = '<div class="sns-upcard" role="button" tabindex="0">' +
        '<span class="sns-upcard__date"><span class="sns-upcard__mon">' + MON3[+p[1] - 1] + '</span>' +
        '<span class="sns-upcard__day">' + (+p[2]) + '</span></span>' +
        '<span class="sns-upcard__body"><p class="sns-upcard__t"></p><p class="sns-upcard__meta"></p></span>' +
        '<span class="sns-badge sns-badge--' + badgeCls + '"></span></div>';
      li.querySelector(".sns-upcard__t").textContent = ev.title;
      li.querySelector(".sns-upcard__meta").textContent =
        [ev.venue, [ev.city, ev.state].filter(Boolean).join(", ")].filter(Boolean).join(" · ") || fmtDate(d.date);
      li.querySelector(".sns-badge").textContent = badgeTxt || "";
      var open = function () { openModal(ev, d.date); };
      li.querySelector(".sns-upcard").addEventListener("click", open);
      li.querySelector(".sns-upcard").addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
      });
      upList.appendChild(li);
    });
    upMore.style.display = list.length > upShown ? "" : "none";
  }
  upMore.addEventListener("click", function () { upShown += 6; renderUp(); });

  // ---------- modal ----------
  var modal = root.querySelector(".sns-modal");
  var lastFocus = null;
  function openModal(ev, dateKey) {
    lastFocus = document.activeElement;
    var badgeCls = ev.eventStatus === "scheduled" ? ev.status : ev.eventStatus;
    var badgeTxt = ev.eventStatus === "scheduled" ? STATUS_LABEL[ev.status] : EVENT_NOTE[ev.eventStatus];
    modal.querySelector(".sns-modal__badge").className = "sns-badge sns-badge--" + badgeCls + " sns-modal__badge";
    modal.querySelector(".sns-modal__badge").textContent = badgeTxt || "";
    modal.querySelector(".sns-modal__t").textContent = ev.title;
    var when = ev.days.length > 1
      ? fmtDate(ev.days[0].date) + " – " + fmtDate(ev.days[ev.days.length - 1].date)
      : fmtDate(ev.days[0].date);
    var day = ev.days.filter(function (d) { return d.date === dateKey; })[0] || ev.days[0];
    var t = clock(day.start); var te = clock(day.end);
    modal.querySelector("[data-when]").textContent = when + (t ? " · " + t + (te ? "–" + te : "") : "");
    modal.querySelector("[data-where]").textContent =
      [ev.venue, ev.address, [ev.city, ev.state].filter(Boolean).join(", ")].filter(Boolean).join(" · ");
    modal.querySelector(".sns-modal__desc").textContent = ev.description || "";
    var site = modal.querySelector("[data-site]");
    if (ev.url) { site.style.display = ""; site.href = ev.url; } else site.style.display = "none";
    var details = modal.querySelector("[data-details]");
    if (ev.article) { details.style.display = ""; details.href = "/blogs/events/" + ev.article; }
    else details.style.display = "none";
    modal.classList.add("open");
    modal.querySelector(".sns-modal__close").focus();
    document.addEventListener("keydown", onKey);
  }
  function closeModal() {
    modal.classList.remove("open");
    document.removeEventListener("keydown", onKey);
    if (lastFocus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === "Escape") closeModal(); }
  modal.querySelector(".sns-modal__bg").addEventListener("click", closeModal);
  modal.querySelector(".sns-modal__close").addEventListener("click", closeModal);

  render(); renderUp();
})();
